import { Route, HashRouter as Router, Routes } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import AccountRedirectPage from './pages/AccountRedirectPage';
import ConfirmPage from './pages/ConfirmPage';
import DomainPage from './pages/DomainPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import ResetPasswordConfirmPage from './pages/ResetPasswordConfirmPage';
import ResetPasswordEmailSentPage from './pages/ResetPasswordEmailSentPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RootPage from './pages/RootPage';
import SubscriptionsConfirmPage from './pages/SubscriptionsConfirmPage';
import ActivateDomainPage from './pages/integration/ActivateDomainPage';
import PaymentSelectPage from './pages/integration/onbording/PaymentSelectPage';
import SuperAdminInvoiceDetailsPage from './pages/superAdmin/SuperAdminInvoiceDetailsPage';
import SuperAdminInvoiceNewPage from './pages/superAdmin/SuperAdminInvoiceNewPage';
import DomainCreatePage from './pages/DomainCreatePage';
import OAuthConsentPage from './pages/oauth/OAuthConsentPage';
import SuperAdminPage from './pages/superAdmin/SuperAdminPage';

const AppBody = ({ authenticatedUser }) => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/confirm/:confirmationToken" element={<ConfirmPage />} />
        {/* User authenticated routes */}
        <Route element={<ProtectedRoute isAllowed={authenticatedUser} redirectPath="/login" />}>
          <Route path="/accounts/:accountId/domains/new" element={<DomainCreatePage />} />
          <Route path="/accounts/:accountId/domains/:domainId/activate" element={<ActivateDomainPage />} />
          <Route
            path="/accounts/:accountId/domains/:domainId/subscriptionsConfirm"
            element={<SubscriptionsConfirmPage />}
          />
          <Route path="/accounts/:accountId/domains/:domainId/*" element={<DomainPage />} />
          <Route path="/accounts/:accountId/payment/" element={<PaymentSelectPage />} />
          <Route path="/accounts/:accountId" element={<AccountRedirectPage />} />
          <Route path="/oauth/consent" element={<OAuthConsentPage />} />
        </Route>

        {/* User not authenticated routes */}
        <Route element={<ProtectedRoute isAllowed={!authenticatedUser} redirectPath="/" />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/resetPassword">
            <Route index element={<ResetPasswordPage />} />
            <Route path="emailSent" element={<ResetPasswordEmailSentPage />} />
            <Route path="confirm/:resetPasswordToken" element={<ResetPasswordConfirmPage />} />
          </Route>
        </Route>

        {/* Super admin routes */}
        <Route
          element={
            <ProtectedRoute
              isAllowed={authenticatedUser && authenticatedUser.userRoles.some((r) => r.role === 'superAdmin')}
              redirectPath="/"
            />
          }
        >
          <Route path="/superAdmin" element={<SuperAdminPage />} />
          <Route path="/superAdmin/:section" element={<SuperAdminPage />} />
          <Route path="/superAdmin/invoices/new" element={<SuperAdminInvoiceNewPage />} />
          <Route path="/superAdmin/invoices/:id" element={<SuperAdminInvoiceDetailsPage />} />
        </Route>

        {/* Public routes */}
        <Route path="/" element={<RootPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default AppBody;
